import { Container } from '../../components/Container'
import CategoryTabs from './components/CategoryTabs'
import { ProgressTracker } from './components/ProgressTracker'

/**
 * This is a temporary component to group all the new dashboard components
 * and features until we can refactor the entire dashboard.
 * It will probably be removed or refactored in the future.
 */

const DashboardV4 = () => {
  return (
    <Container>
      <CategoryTabs>
        <CategoryTabs.List>
          <CategoryTabs.Item tabId="resumes">Building Resumes</CategoryTabs.Item>
          <CategoryTabs.Item tabId="jobs">Looking for jobs</CategoryTabs.Item>
          <CategoryTabs.Item tabId="interviews">Interviewing for jobs</CategoryTabs.Item>
          <CategoryTabs.Item tabId="careers">Learning</CategoryTabs.Item>
        </CategoryTabs.List>

        <CategoryTabs.Content tabId="resumes">
          <ProgressTracker categoryId="resumes" />
        </CategoryTabs.Content>
        <CategoryTabs.Content tabId="jobs">
          <ProgressTracker categoryId="jobs" />
        </CategoryTabs.Content>
        <CategoryTabs.Content tabId="interviews">
          <ProgressTracker categoryId="interviews" />
        </CategoryTabs.Content>
        <CategoryTabs.Content tabId="careers">
          <ProgressTracker categoryId="careers" />
        </CategoryTabs.Content>

        {/* Job Listing will be here */}

        {/* Banners will be here */}
      </CategoryTabs>
    </Container>
  )
}

export default DashboardV4
